import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, auth } from '../firebase';
import { collection, onSnapshot, query, where, deleteDoc, writeBatch, doc, getDocs } from 'firebase/firestore';
import Modal from '../components/Modal';
// YENİ: Log
import { logIslem } from '../utils/logger';

function Tedarikciler() {
  const [tedarikciler, setTedarikciler] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); 
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCari, setSelectedCari] = useState(null); 
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const q = query(collection(db, 'cariler'), where("cariTipi", "==", "Tedarikçi"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const list = [];
      querySnapshot.forEach((doc) => { list.push({ id: doc.id, ...doc.data() }); });
      list.sort((a, b) => (a.adSoyad || a.firmaSahis).localeCompare(b.adSoyad || b.firmaSahis));
      setTedarikciler(list);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // --- KRİTİK DÜZELTME: ARTIK TEDARİKÇİ DETAY SAYFASINA GİDİYOR ---
  const handleRowClick = (cariId) => {
    navigate(`/tedarikciler/${cariId}`); 
  };

  const handleDeleteClick = (e, cari) => { e.stopPropagation(); setSelectedCari(cari); setIsModalOpen(true); };
  const handleCloseModal = () => { setIsModalOpen(false); setSelectedCari(null); };

  const handleConfirmDelete = async () => {
    if (!selectedCari) return;
    try {
      const batch = writeBatch(db);
      const cariId = selectedCari.id;
      const silinecekIsim = selectedCari.adSoyad || selectedCari.firmaSahis;

      batch.delete(doc(db, 'cariler', cariId));
      const odemelerQuery = query(collection(db, 'odemeler'), where("cariId", "==", cariId));
      const odemelerSnapshot = await getDocs(odemelerQuery);
      odemelerSnapshot.forEach((doc) => { batch.delete(doc.ref); });
      
      await batch.commit();

      // LOG
      const userEmail = auth.currentUser ? auth.currentUser.email : "Bilinmeyen";
      logIslem("Tedarikçi Silme", `Silinen: ${silinecekIsim} (ID: ${cariId})`, userEmail);

    } catch (err) { alert("Silinemedi."); }
    handleCloseModal();
  };

  return (
    <>
      <div className="admin-page">
        <div className="admin-header">
          <h1 className="brand-logo admin-brand-header" onClick={() => navigate('/admin/dashboard')} style={{ cursor: 'pointer', flex: 1 }} title="Admin Paneline Dön">
            <img src="/logo.png" width="50" alt="" />
            ARAS ASAF İNŞAAT – TEDARİKÇİ LİSTESİ
          </h1>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
              <div className="date-time-info" style={{marginRight: '10px'}}>{now.toLocaleDateString("tr-TR")} | {now.toLocaleTimeString("tr-TR")}</div>
               <button onClick={() => navigate('/admin/dashboard')} className="admin-button-secondary small">← Geri Dön</button>
          </div>
        </div>
        
        <div className="admin-table-container">
          {loading && <p className="loading-text">Yükleniyor...</p>}
          {!loading && (
            <table className="admin-table">
              <thead><tr><th>Firma / Şahıs</th><th>Yetkili</th><th>Telefon</th><th>Adres</th><th>Aksiyonlar</th></tr></thead>
              <tbody>
                {tedarikciler.map((cari) => (
                  <tr key={cari.id} className="table-row-clickable" onClick={() => handleRowClick(cari.id)}> 
                    <td>{cari.firmaSahis || '---'}</td>
                    <td>{cari.adSoyad || '---'}</td>
                    <td>{cari.telefon}</td>
                    <td>{cari.adres || '---'}</td>
                    <td style={{ textAlign: 'center' }}>
                      <button className="admin-button-delete" onClick={(e) => handleDeleteClick(e, cari)}>Sil</button>
                    </td>
                  </tr>
                ))}
                {tedarikciler.length === 0 && <tr><td colSpan="5" style={{ textAlign: 'center' }}>Kayıt yok.</td></tr>}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <Modal show={isModalOpen} onClose={handleCloseModal} onConfirm={handleConfirmDelete} title="Silme Onayı">
        <p>Bu tedarikçiyi silmek istediğinize emin misiniz?</p>
      </Modal>
    </>
  );
}
export default Tedarikciler;